<!-- 页面内容 -->

<template>
	<!-- style="max-width: 1472px;margin: 0 auto;" -->
	<div class="container">
		<slot />
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.container {
	max-width: 1472px;
	margin: 0 auto;
}
</style>